module.exports = __webpack_public_path__ + "static/media/logo__0003_IHHS.343602f0.png";